// package: 
// file: grpc-models/Account.proto

var grpc_models_Account_pb = require("../grpc-models/Account_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var AccountProtoService = (function () {
  function AccountProtoService() {}
  AccountProtoService.serviceName = "AccountProtoService";
  return AccountProtoService;
}());

AccountProtoService.Signin = {
  methodName: "Signin",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.SigninRequest,
  responseType: grpc_models_Account_pb.SigninResponse
};

AccountProtoService.OmsUserSignin = {
  methodName: "OmsUserSignin",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.OmsUserSigninRequest,
  responseType: grpc_models_Account_pb.OmsUserSigninResponse
};

AccountProtoService.VerifyCode = {
  methodName: "VerifyCode",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.VerifyCodeRequest,
  responseType: grpc_models_Account_pb.VerifyCodeResponse
};

AccountProtoService.ResetPasswordEmail = {
  methodName: "ResetPasswordEmail",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.ResetPasswordEmailRequest,
  responseType: grpc_models_Account_pb.ResetPasswordEmailResponse
};

AccountProtoService.CheckIfEmailExists = {
  methodName: "CheckIfEmailExists",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.EmailExistsRequest,
  responseType: grpc_models_Account_pb.EmailExistsResponse
};

AccountProtoService.GetUserProfile = {
  methodName: "GetUserProfile",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.GetUserProfileRequest,
  responseType: grpc_models_Account_pb.GetUserProfileResponse
};

AccountProtoService.GetBusinessMasterUser = {
  methodName: "GetBusinessMasterUser",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.GetBusinessMasterUserRequest,
  responseType: grpc_models_Account_pb.GetBusinessMasterUserResponse
};

AccountProtoService.GetAllBusinessUsers = {
  methodName: "GetAllBusinessUsers",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.GetAllBusinessUsersRequest,
  responseType: grpc_models_Account_pb.GetAllBusinessUsersResponse
};

AccountProtoService.CheckTokenExpiry = {
  methodName: "CheckTokenExpiry",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.CheckTokenExpiryRequest,
  responseType: grpc_models_Account_pb.CheckTokenExpiryResponse
};

AccountProtoService.ValidateShortCode = {
  methodName: "ValidateShortCode",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.ValidateShortCodeRequest,
  responseType: grpc_models_Account_pb.ValidateShortCodeResponse
};

AccountProtoService.VerifyGoogleRecaptchaV3Token = {
  methodName: "VerifyGoogleRecaptchaV3Token",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.VerifyGoogleRecaptchaV3TokenRequest,
  responseType: grpc_models_Account_pb.VerifyGoogleRecaptchaV3TokenResponse
};

AccountProtoService.CheckIfPasswordExists = {
  methodName: "CheckIfPasswordExists",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.CheckIfPasswordExistsRequest,
  responseType: grpc_models_Account_pb.CheckIfPasswordExistsResponse
};

AccountProtoService.Signup = {
  methodName: "Signup",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.SignupRequest,
  responseType: grpc_models_Account_pb.SignupResponse
};

AccountProtoService.ResetPassword = {
  methodName: "ResetPassword",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.ResetPasswordRequest,
  responseType: grpc_models_Account_pb.ResetPasswordResponse
};

AccountProtoService.UpdateUserProfile = {
  methodName: "UpdateUserProfile",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.UpdateUserProfileRequest,
  responseType: grpc_models_Account_pb.UpdateUserProfileResponse
};

AccountProtoService.UpdatePassword = {
  methodName: "UpdatePassword",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.UpdatePasswordRequest,
  responseType: grpc_models_Account_pb.UpdatePasswordResponse
};

AccountProtoService.GoogleSignUp = {
  methodName: "GoogleSignUp",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.GoogleSignUpRequest,
  responseType: grpc_models_Account_pb.GoogleSignUpResponse
};

AccountProtoService.UpdateUserActiveStatus = {
  methodName: "UpdateUserActiveStatus",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.UpdateUserActiveStatusRequest,
  responseType: grpc_models_Account_pb.UpdateUserActiveStatusResponse
};

AccountProtoService.ChangeBusinessUserPassword = {
  methodName: "ChangeBusinessUserPassword",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.ChangeBusinessUserPasswordRequest,
  responseType: grpc_models_Account_pb.ChangeBusinessUserPasswordResponse
};

AccountProtoService.UpdateBusinessMasterUser = {
  methodName: "UpdateBusinessMasterUser",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.UpdateBusinessMasterUserRequest,
  responseType: grpc_models_Account_pb.UpdateBusinessMasterUserResponse
};

AccountProtoService.UpdatePasswordsToHash = {
  methodName: "UpdatePasswordsToHash",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.UpdatePasswordsToHashRequest,
  responseType: grpc_models_Account_pb.UpdatePasswordsToHashResponse
};

AccountProtoService.GetUsersWithHashedPasswords = {
  methodName: "GetUsersWithHashedPasswords",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.GetUsersWithHashedPasswordsRequest,
  responseType: grpc_models_Account_pb.GetUsersWithHashedPasswordsResponse
};

AccountProtoService.LoginWithFacebook = {
  methodName: "LoginWithFacebook",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.LoginWithFacebookRequest,
  responseType: grpc_models_Account_pb.LoginWithFacebookResponse
};

AccountProtoService.SignUpWithFacebookSdkAccessToken = {
  methodName: "SignUpWithFacebookSdkAccessToken",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.LoginWithFacebookSdkAccessTokenRequest,
  responseType: grpc_models_Account_pb.LoginWithFacebookResponse
};

AccountProtoService.ShopifySignUp = {
  methodName: "ShopifySignUp",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.ShopifySignUpRequest,
  responseType: grpc_models_Account_pb.ShopifySignUpResponse
};

AccountProtoService.CompleteSignUp = {
  methodName: "CompleteSignUp",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.CompleteSignUpRequest,
  responseType: grpc_models_Account_pb.CompleteSignUpResponse
};

AccountProtoService.CompleteSignUpWithFacebook = {
  methodName: "CompleteSignUpWithFacebook",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.CompleteSignUpWithFacebookRequest,
  responseType: grpc_models_Account_pb.CompleteSignUpResponse
};

AccountProtoService.CompleteSignUpWithFacebookSdkAccessToken = {
  methodName: "CompleteSignUpWithFacebookSdkAccessToken",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.CompleteSignUpWithFacebookSdkAccessTokenRequest,
  responseType: grpc_models_Account_pb.CompleteSignUpResponse
};

AccountProtoService.CompleteSignUpWithGoogle = {
  methodName: "CompleteSignUpWithGoogle",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.CompleteSignUpWithGoogleRequest,
  responseType: grpc_models_Account_pb.CompleteSignUpResponse
};

AccountProtoService.SendOTP = {
  methodName: "SendOTP",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.SendOTPRequest,
  responseType: grpc_models_Account_pb.SendOTPResponse
};

AccountProtoService.ValidateOTP = {
  methodName: "ValidateOTP",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.ValidateOTPRequest,
  responseType: grpc_models_Account_pb.ValidateOTPResponse
};

AccountProtoService.SendOTPAnonymous = {
  methodName: "SendOTPAnonymous",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.SendOTPAnonymousRequest,
  responseType: grpc_models_Account_pb.SendOTPResponse
};

AccountProtoService.ValidateOTPAnonymous = {
  methodName: "ValidateOTPAnonymous",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.ValidateOTPAnonymousRequest,
  responseType: grpc_models_Account_pb.ValidateOTPResponse
};

AccountProtoService.AddPassword = {
  methodName: "AddPassword",
  service: AccountProtoService,
  requestStream: false,
  responseStream: false,
  requestType: grpc_models_Account_pb.AddPasswordRequest,
  responseType: grpc_models_Account_pb.AddPasswordResponse
};

exports.AccountProtoService = AccountProtoService;

function AccountProtoServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

AccountProtoServiceClient.prototype.signin = function signin(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.Signin, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.omsUserSignin = function omsUserSignin(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.OmsUserSignin, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.verifyCode = function verifyCode(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.VerifyCode, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.resetPasswordEmail = function resetPasswordEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.ResetPasswordEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.checkIfEmailExists = function checkIfEmailExists(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.CheckIfEmailExists, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.getUserProfile = function getUserProfile(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.GetUserProfile, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.getBusinessMasterUser = function getBusinessMasterUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.GetBusinessMasterUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.getAllBusinessUsers = function getAllBusinessUsers(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.GetAllBusinessUsers, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.checkTokenExpiry = function checkTokenExpiry(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.CheckTokenExpiry, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.validateShortCode = function validateShortCode(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.ValidateShortCode, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.verifyGoogleRecaptchaV3Token = function verifyGoogleRecaptchaV3Token(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.VerifyGoogleRecaptchaV3Token, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.checkIfPasswordExists = function checkIfPasswordExists(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.CheckIfPasswordExists, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.signup = function signup(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.Signup, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.resetPassword = function resetPassword(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.ResetPassword, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.updateUserProfile = function updateUserProfile(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.UpdateUserProfile, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.updatePassword = function updatePassword(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.UpdatePassword, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.googleSignUp = function googleSignUp(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.GoogleSignUp, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.updateUserActiveStatus = function updateUserActiveStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.UpdateUserActiveStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.changeBusinessUserPassword = function changeBusinessUserPassword(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.ChangeBusinessUserPassword, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.updateBusinessMasterUser = function updateBusinessMasterUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.UpdateBusinessMasterUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.updatePasswordsToHash = function updatePasswordsToHash(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.UpdatePasswordsToHash, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.getUsersWithHashedPasswords = function getUsersWithHashedPasswords(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.GetUsersWithHashedPasswords, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.loginWithFacebook = function loginWithFacebook(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.LoginWithFacebook, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.signUpWithFacebookSdkAccessToken = function signUpWithFacebookSdkAccessToken(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.SignUpWithFacebookSdkAccessToken, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.shopifySignUp = function shopifySignUp(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.ShopifySignUp, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.completeSignUp = function completeSignUp(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.CompleteSignUp, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.completeSignUpWithFacebook = function completeSignUpWithFacebook(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.CompleteSignUpWithFacebook, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.completeSignUpWithFacebookSdkAccessToken = function completeSignUpWithFacebookSdkAccessToken(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.CompleteSignUpWithFacebookSdkAccessToken, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.completeSignUpWithGoogle = function completeSignUpWithGoogle(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.CompleteSignUpWithGoogle, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.sendOTP = function sendOTP(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.SendOTP, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.validateOTP = function validateOTP(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.ValidateOTP, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.sendOTPAnonymous = function sendOTPAnonymous(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.SendOTPAnonymous, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.validateOTPAnonymous = function validateOTPAnonymous(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.ValidateOTPAnonymous, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountProtoServiceClient.prototype.addPassword = function addPassword(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountProtoService.AddPassword, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.AccountProtoServiceClient = AccountProtoServiceClient;

